module.exports = __webpack_public_path__ + "static/media/Galeria_Empresariales_3-1.dbc2dd29.jpg";